var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3333 18.2409C14.9357 18.2409 18.6667 14.5099 18.6667 9.90755C18.6667 5.30518 14.9357 1.57422 10.3333 1.57422C5.73096 1.57422 2 5.30518 2 9.90755C2 14.5099 5.73096 18.2409 10.3333 18.2409ZM7.76161 13.7144C8.04282 14.0487 8.43358 14.2409 8.83533 14.2409C9.23569 14.2404 9.62602 14.0477 9.90583 13.7139L14.6761 8.02967C15.0224 7.6164 15.0185 6.95123 14.6676 6.54383C14.3156 6.13597 13.7499 6.14057 13.4029 6.55384L8.83316 11.9995L6.86316 9.6526C6.51725 9.23977 5.95087 9.23563 5.5992 9.64296C5.24792 10.0499 5.24439 10.7152 5.59069 11.1284L7.76161 13.7144Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.b159b57898d112585a7d8718b90618c9.svg";
export { ForwardRef as ReactComponent };